// extracted by mini-css-extract-plugin
export default {"container":"PhotoNameTab_container__XtXMq","rate":"PhotoNameTab_rate__y-laa","nameRate":"PhotoNameTab_nameRate__50n5C","photo":"PhotoNameTab_photo__HEiGO"};